import React from 'react';

import { formatNumber } from '../../../../../../utils/global';

const MiniStat = ({ icon, stat }) => {
  return (
    <div className="mini-stat">
      {icon} {stat ? formatNumber(stat) : '--'}
    </div>
  );
};

export default MiniStat;
